import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Assets from "@/pages/Assets.vue";
import DeletedAssets from "@/pages/DeletedAssets.vue";
import Dashboard from "@/pages/Dashboard.vue";
import EmailProperties from "@/pages/EmailProperties.vue";
import Install from "@/pages/Install.vue";
import LivingOptions from "@/pages/LivingOptions.vue";
import Login from "@/pages/Login.vue";
import NavigationItems from "@/pages/NavigationItems.vue";
import PageParentWrapper from "@/pages/PageParentWrapper.vue";
import Pages from "@/pages/Pages.vue";
import PageEdit from "@/pages/PageEdit.vue";
import PageNew from "@/pages/PageNew.vue";
import ResetPassword from "@/pages/ResetPassword.vue";
import Settings from "@/pages/Settings.vue";
import UpdatePassword from "@/pages/UpdatePassword.vue";
import Users from "@/pages/Users.vue";
import UserNew from "@/pages/UserNew.vue";
import UserUpdate from "@/pages/UserUpdate.vue";
import Heatmaps from "@/pages/Heatmaps.vue";
import LivingOptionEdit from "@/pages/LivingOptionEdit.vue";
import SubsectionEdit from "@/pages/SubsectionEdit.vue";
import PropertyEdit from "@/pages/PropertyEdit.vue";
import DwellingEdit from "@/pages/DwellingEdit.vue";
import PackageEdit from "@/pages/PackageEdit.vue";
import Setup from "@/pages/Setup.vue";

const routes = [
  {
    path: "/install",
    name: "install",
    component: Install
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/reset-password",
    name: "reset password",
    component: ResetPassword
  },
  {
    path: "/reset-password/:resetToken",
    name: "update password",
    component: UpdatePassword
  },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard", // change back to dashboard once new homepage built
    meta: {
      requiresAuth: true,
      requiresAccess: false
    },
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard
      },
      {
        path: "setup",
        name: "setup",
        component: Setup
      },
      {
        path: "assets",
        name: "assets",
        component: Assets,
        meta: {
          requiresAccess: true
        }
      },
      {
        path: "deleted-assets",
        name: "Deleted Assets",
        component: DeletedAssets,
        meta: {
          requiresAccess: true
        }
      },
      {
        path: "users",
        component: PageParentWrapper,
        children: [
          {
            path: "/",
            name: "User List",
            component: Users
          },
          {
            path: "new",
            name: "create user",
            component: UserNew
          },
          {
            path: "update/:userId",
            name: "update user",
            component: UserUpdate
          }
        ],
        meta: {
          requiresAccess: true
        }
      },
      {
        path: "live",
        name: "live",
        component: LivingOptions,
        children: [
          {
            path: "masterplan",
            name: "Masterplan"
          },
          {
            path: "subsections",
            name: "Subsections"
          },
          {
            path: "properties",
            name: "Properties"
          },
          {
            path: "dwellings",
            name: "Dwellings"
          },
          {
            path: "packages",
            name: "Packages"
          }
        ],
        meta: {
          requiresAccess: true
        }
      },
      {
        path: "live/masterplan/:id",
        component: LivingOptionEdit
      },
      {
        path: "live/subsections/:id",
        component: SubsectionEdit
      },
      {
        path: "live/properties/:id",
        component: PropertyEdit
      },
      {
        path: "live/dwellings/:id",
        component: DwellingEdit
      },
      {
        path: "live/packages/:id",
        component: PackageEdit
      },
      {
        path: "pages",
        component: PageParentWrapper,
        children: [
          {
            path: "/",
            name: "Pages List",
            component: Pages
          },
          {
            path: "new",
            name: "Create new page",
            component: PageNew
          },
          {
            path: ":id",
            name: "Edit page",
            component: PageEdit
          }
        ],
        meta: {
          requiresAccess: true
        }
      },
      {
        path: "navigation",
        name: "navigation",
        component: NavigationItems,
        meta: {
          requiresAccess: true
        }
      },
      {
        path: "settings",
        name: "settings",
        component: Settings,
        children: [
          {
            path: "rest",
            name: "Rest"
          },
          {
            path: "category",
            name: "Category"
          },
          {
            path: "general",
            name: "General"
          },
          {
            path: "live",
            name: "Live"
          }
        ],
        meta: {
          requiresAuth: true,
          requiresAccess: true
        }
      },
      {
        path: "email-properties",
        name: "Email Properties",
        component: EmailProperties,
        meta: {
          requiresAccess: false
        }
      },
      {
        path: "heatmaps",
        name: "heatmaps",
        component: Heatmaps,
        children: [
          {
            path: "sessions",
            name: "Sessions"
          },
          {
            path: "pages",
            name: "Pages"
          }
        ],
        meta: {
          requiresAccess: true
        }
      }
    ]
  },
  { path: "*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
